import EMAIL_BTN from '@icons/email-btn.svg';
import LOCATION_BTN from '@icons/location-btn.svg';
// import PHONE_BTN from '@icons/phone-btn.svg';
import './style.scss';

const Footer = () => {
	return (
		<div className='footer-wrapper'>
			<span className='section-title'>Contact us</span>

			<span className='intro-text'>Have a Problem with your Product?</span>
			<span className='description'>
				Our team is here and ready to assist you.
			</span>

			<div className='footer-item'>
				<button>
					<img src={EMAIL_BTN} alt='email-btn' />
				</button>

				<span className='item-title'>Email</span>
				<span className='item-description'>
					Our friendly team is here to help.
				</span>
				<a className='item-value' href='mailto: support@drxasia.com'>
					support@drxasia.com
				</a>
			</div>

			<div className='footer-item'>
				<button>
					<img src={LOCATION_BTN} alt='email-btn' />
				</button>

				<span className='item-title'>Office</span>
				<span className='item-description'>
					Come say hello at our office HQ.
				</span>
				<a
					className='item-value address'
					href='https://www.google.com/maps/place/Komp.+Ruko+Royal+Sunter,+Jl.+Danau+Sunter+Selatan,+RT.10%2FRW.11,+Sunter+Jaya,+Kec.+Tj.+Priok,+Jkt+Utara,+Daerah+Khusus+Ibukota+Jakarta+14350/data=!4m2!3m1!1s0x2e69f567c174c895:0x77adf32f2ac1bec5?utm_source=mstt_1&entry=gps&lucs=47068609&g_ep=CAESCTExLjgzLjMwMRgAINeCAyoINDcwNjg2MDlCAklE'
					target='_blank'
					rel='noreferrer'
				>
					Komp. Ruko Royal Sunter <br /> Jl. Danau Sunter Selatan, Jakarta
					Utara, DKI Jakarta 14350
				</a>
			</div>

			{/* <div className='footer-item'>
				<button>
					<img src={PHONE_BTN} alt='email-btn' />
				</button>

				<span className='item-title'>Phone</span>
				<span className='item-description'>Mon-Fri from 8am to 5pm.</span>
				<a className='item-value' href='tel:+6285217498588'>
					+62 852 1749 8588
				</a>
			</div> */}
		</div>
	);
};

export default Footer;
